import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';
import { Colors, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.SINGLE};
`;

export const TabContainer = styled.div<{
  dockTabsAtTop?: boolean;
  showTabsOnMobile?: boolean;
  showTabsOnTablet?: boolean;
}>`
  display: none;

  ${ifProp(
    `dockTabsAtTop`,
    css`
      position: sticky;
      top: 0;
      background: ${Colors.GRAY_LITE_30};
      z-index: 1;
    `
  )}

  ${ifProp(
    `showTabsOnMobile`,
    Mixins.Media.maxWidthSmall(css`
      display: block;
    `)
  )}

  ${ifProp(
    `showTabsOnTablet`,
    Mixins.Media.maxWidthMedium(css`
      display: block;
    `)
  )}
`;

export const TabContentWrapper = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.SINGLE};
  max-height: 100%;
  transition: all ${Transition.Time.BASE} 0;
`;

export const TabContentWrapperLarge = styled(TabContentWrapper)`
  flex: 1 1 200%;
  width: auto;

  ${Mixins.Media.maxWidthLarge(`
    flex: 1 1 100%;
    width: auto;
  `)}
`;

export const TabContentsWrapper = styled.div<{
  isLeftColumnActive?: boolean;
  showTabsOnMobile?: boolean;
  showTabsOnTablet?: boolean;
  emphasizeColumns?: boolean;
}>`
  flex-direction: row;
  display: flex;
  gap: ${ifProp('emphasizeColumns', Spacing.SINGLE_HALF, Spacing.SINGLE)};
  height: 100%;

  ${({ isLeftColumnActive, showTabsOnMobile, showTabsOnTablet }) =>
    match({ isLeftColumnActive, showTabsOnMobile, showTabsOnTablet })
      .with({ isLeftColumnActive: true, showTabsOnMobile: true }, () =>
        Mixins.Media.maxWidthSmall(css`
          transform: translateX(0);

          & > ${TabContentWrapper}:last-child {
            max-height: 0%;
            height: 0;
            overflow: hidden;
          }
        `)
      )
      .with({ isLeftColumnActive: false, showTabsOnMobile: true }, () =>
        Mixins.Media.maxWidthSmall(css`
          transform: translateX(calc(-50% - ${Spacing.HALF}));

          & > ${TabContentWrapper}:first-child {
            max-height: 0%;
            height: 0;
            overflow: hidden;
          }
        `)
      )
      .with({ isLeftColumnActive: true, showTabsOnTablet: true }, () =>
        Mixins.Media.maxWidthMedium(css`
          transform: translateX(0);

          & > ${TabContentWrapper}:last-child {
            max-height: 0%;
            height: 0;
            overflow: hidden;
          }
        `)
      )
      .with({ isLeftColumnActive: false, showTabsOnTablet: true }, () =>
        Mixins.Media.maxWidthMedium(css`
          transform: translateX(calc(-50% - ${Spacing.HALF}));

          & > ${TabContentWrapper}:first-child {
            max-height: 0%;
            height: 0;
            overflow: hidden;
          }
        `)
      )
      .otherwise(() => css``)}

  ${ifProp(
    `showTabsOnMobile`,
    Mixins.Media.maxWidthSmall(css`
      transition: all ${Transition.Time.BASE};
      width: calc(200% + ${Spacing.SINGLE});
      gap: ${Spacing.SINGLE};
    `)
  )}

  ${ifProp(
    `showTabsOnTablet`,
    Mixins.Media.maxWidthMedium(css`
      transition: all ${Transition.Time.BASE};
      width: calc(200% + ${Spacing.SINGLE});
      gap: ${Spacing.SINGLE};
    `)
  )}
`;

export const TabContentContainer = styled.div`
  ${Mixins.Media.maxWidthMedium(css`
    overflow: hidden;
  `)}
`;
